import { ref } from 'vue'

export const instanceRefreshCallback = ref<Function>()
